<div class="page">
  <div class="content">
    <div class="text">Exam Performance</div>
    <nz-progress [nzPercent]="score" [nzStrokeColor]="{ '0%': '#f85a7e', '50%': '#d96afa', '100%': '#3d7af8' }"
                 [nzWidth]="300" nzStatus="active"
                 nzType="circle"></nz-progress>
  </div>
</div>
